<template>
  <div class="empty-layout main-panel">
    <Header v-if="$router.currentRoute.name !== 'home'" />
    <div class="content-wrapper">
      <transition name="slide" mode="out-in">
        <router-view :key="$route.path" />
      </transition>
    </div>
    <Footer v-if="$router.currentRoute.name !== 'home'" />
    <CookiesBar />
  </div>
</template>

<script>
import CookiesBar from '../components/CookiesBar'
import Footer from '../components/Footer'
export default {
  name: 'EmptyLayout',
  components: {
    Footer,
    CookiesBar,
  },
}
</script>

<style scoped lang="scss">
.empty-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  .content-wrapper {
    padding: 0;
    flex: 1 0 auto;
    background-color: #eee;
  }
}
.main-panel {
  padding: 0;
  float: none;
  width: 100%;
}
.slide-enter-active,
.slide-leave-active {
  transition: opacity 1s, transform 1s;
}
.slide-enter {
  transform: translateX(100%);
  opacity: 0;
}
.slide-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
</style>
